<template>
  <footer>
    <img src="../assets/divide_img.jpg">
    <div class="footer_info">
      <div class="item">
        <div>
          <img src="../assets/logo.png" alt="logo" style="height: 37px">
        </div>
        <div style="margin-top: 17px;margin-left: 53px" v-if="false">
          <a><img src="../assets/facebook.png" alt="logo" style="width: 28px;height: 28px"></a>
          <a><img src="../assets/youtube.png" alt="logo" style="width: 28px;height: 28px;margin-left: 6px"></a>
          <a><img src="../assets/tiktok.png" alt="logo" style="width: 28px;height: 28px;margin-left: 5px"></a>
        </div>
        <div class="item_box">
          <div class="title">Longyan Dike Trading Co., Ltd</div>
          <div class="des">
            Working hours:
            <span style="font-weight: 400">9:00-18:00</span><br>
            Email: <span style="font-weight: 400">
            support@printbelle.com</span><br>
            Fulfillment Address: <span style="font-weight: 400">
            Printing Industry Park,<br>
            Longyan City, Fujian Province, China</span><br>
            Media Address:
            <span style="font-weight: 400">
            10/F Easey Commercial<br>
            Building 253-261 Hennessy Road Wanchai<br>
            HongKong, China
            </span>
          </div>
        </div>
      </div>
      <div class="item_1" style="margin-left: 228px">
        <div class="title">About Us</div>
        <a @click="goto('About Us')">About Us</a>
        <a :href="skypeConfig">Contact Us</a>
      </div>
      <div class="item_1" style="margin-left: 219px">
        <div class="title">Policy</div>
        <a
          @click="gotoUrl('help/detail/returns')">Returns</a>
        <a
          @click="gotoUrl('help/detail/privacy-policy')">Privacy
          Policy</a>
        <a
          @click="gotoUrl('help/detail/printbelle-platform-user-service-agreement')">Terms
          of Service</a>
        <a
          @click="gotoUrl('help/detail/copyright-notice')">Copyright
          Notice</a>
      </div>
      <div class="item_1" style="margin-left: 190px">
        <div class="title">Help center</div>
        <a
          @click="gotoUrl('help/detail/overview-of-platform-features')">Getting
          Started</a>
        <a
          @click="gotoUrl('help/detail/my-products')">Product
          and Design</a>
        <a
          @click="gotoUrl('help/detail/how-to-create-an-order')">Order</a>
        <a
          @click="gotoUrl('help/detail/logistics-tracking')">Shipping
          and Price</a>
      </div>
      <div class="item_1" style="margin-left: 178px">
        <div class="title">Features</div>
        <a
          @click="gotoUrl('help/detail/introduction-to-membership-system')">Account</a>
        <a
          @click="gotoUrl('help/detail/instructions-for-using-the-new-designer')">New
          Designer</a>
        <a
          @click="gotoUrl('help/detail/integration')">Integration</a>
        <a href="https://documenter.getpostman.com/view/25923095/2s93RL1vvB" target="_blank">API Docs</a>
      </div>
    </div>
    <div class="divide"></div>
    <div class="image-container">
      <img class="image" style="width: 1499px" src="../assets/partners.png" alt="Partners">
    </div>
    <div class="printbelle">© 2024 PRINTBELLE. All Rights Reserved</div>
  </footer>
</template>
<script>

import {get} from '@/api'

export default {
  components: {},
  data () {
    return {
      showModal: false,
      skypeConfig: ''
    }
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    hideModal () {
      this.showModal = false
    },
    getSkypeConfig () {
      get('/merchant/index/config/skype')
        .then(response => {
          this.skypeConfig = 'skype:' + response.data + '?chat'
        })
        .catch(error => {
          console.error(error)
        })

    },
    goto (name) {
      this.$router.push({name: name})
    },
    gotoUrl (url) {
      window.open(process.env.VUE_APP_FULFILLMENT + url, '_blank')
    },
    openModal (type) {
      if (type === 0) {
        window.open('/returns', '_blank')
      } else {
        window.open('/legal', '_blank')
      }
    }
  }
}
</script>
<style scoped lang="less">

footer {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;

  .footer_info {
    font-family: Roboto;
    display: flex;
    margin-top: 67px;
    margin-left: 212px;

    .item {
      display: flex;
      flex-direction: column;

      .item_box {
        margin-top: 19px;
        margin-bottom: 26px;

        .title {
          font-family: Roboto;
          font-weight: bold;
          font-size: 20px;
          color: #222222;
          line-height: 25px;
          margin-bottom: 28px;
        }

        .des {
          font-family: Roboto;
          font-weight: bold;
          font-size: 14px;
          color: #222222;
          line-height: 30px;
        }

      }
    }

    .item_1 {
      display: flex;
      flex-direction: column;
      margin-top: 3px;

      .title {
        font-weight: bold;
        font-size: 18px;
        color: #353A47;
        margin-bottom: 18px;
      }

      a {
        font-weight: 500;
        font-size: 14px;
        color: #353A47;
        line-height: 35px;
        transition: color 0.3s ease;
      }

      a:hover {
        color: #343183;
      }
    }
  }

  .divide {
    width: 1499px;
    height: 1px;
    background: #EAEAEA;
    margin-left: 214px;
  }

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    .image {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .printbelle {
    font-weight: 400;
    font-size: 14px;
    color: #212121;
    line-height: 1px;
    margin-top: 60px;
    margin-bottom: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue